import { Container, Navbar } from 'react-bootstrap';

export const FootBar = () => {
  return (
    <>
      <Navbar fixed="bottom">
        <Container fluid="xl">
          <div className="w-100 d-flex justify-content-center align-items-center">
            <a href="https://www.sogo-medical.co.jp/others/security.php" className="me-4">
              情報セキュリティー方針
            </a>
            <a href="https://www.sogo-medical.co.jp/others/privacypolicy/" className="me-4">
              個人情報保護方針
            </a>
            <span className="copy-right">© SOGO MEDICAL CO., LTD. All Rights Reserved.</span>
          </div>
        </Container>
      </Navbar>
    </>
  );
};
